/**
 *
 * @param {string[]} functionKeywords
 * @returns
 */
export const makeGrammar = functionKeywords => {
	const FunctionKeywords = functionKeywords.map(keyword => `"${keyword}"`).join(' | ');

	return String.raw`
@precedence { comp @left, pri @left, times @left, plus @left }

@top Script {
	Statement { Expression }?
}

@skip { whitespace | LineComment }

Expression[@isGroup=EXP] {
	AddExp |
	MulExp |
	ExpExp |
	PriorityExp |
	// SignExp |
	Number |
	Function |
	Comparison |
	String |
	Boolean |
	Null
}

AddExp { Expression !plus ("+" | "-") Expression }
MulExp { Expression !times ("*" | "/") Expression }
ExpExp { Expression !pri "^" Expression }
PriorityExp { "(" Expression ")" }
// SignExp { Sign Expression }

Comparison { Expression !comp Comparator Expression }

Param { Expression comma? }

Function { FnKeyword "(" Param* ")" }

@tokens {
	@precedence { LineComment, "/" /*, Sign , "+", "-" */ }

	whitespace { @whitespace+ }
	// Sign { "+" | '-' }
	LineComment { "//" ![\n]* }
	String {
		'"' (![\\\n"] | "\\" _)* '"'? |
		"'" (![\\\n'] | "\\" _)* "'"?
	}
	Number { @digit+ }
	Boolean { "true" | "false" }
	comma { "," }
	Null { "null" }
	Comparator { ">" | "<" | "==" | "!=" | ">=" | "<=" | "<>" | "=" }
	FnKeyword { ${FunctionKeywords} }
}

@detectDelim`;
};
